// 抽奖相关接口
import service from ".."

// 获取数据
export function luckyIndex (params) {
  return service({
    method: 'GET',
    url: "/lucky/info_mobile",
    params
  })
}


// 执行抽奖
export function luckyDeal (params) {
  return service({
    method: 'GET',
    url: "/lucky/deal",
    params
  })
}


// 取消奖品
export function cancelPrize (params) {
  return service({
    method: 'GET',
    url: "/lucky/cancel_prize",
    params
  })
}